import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import LoginModal from './LoginModal';
import './Header.css';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <motion.header
        className={`header ${scrolled ? 'scrolled' : ''}`}
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div className="header-container">
          <a href="#hero" className="header-logo">
            <img src="/images/logo.png" alt="PerformerAI" onError={(e) => { e.target.style.display = 'none'; }} />
          </a>

          <nav className={`header-nav ${isMenuOpen ? 'open' : ''}`}>
            <a href="#features" onClick={() => setIsMenuOpen(false)}>Преимущества</a>
            <a href="#pricing" onClick={() => setIsMenuOpen(false)}>Цены</a>
            <a href="#cases" onClick={() => setIsMenuOpen(false)}>Кейсы</a>
            <a href="#contacts" onClick={() => setIsMenuOpen(false)}>Контакты</a>
            <div className="header-actions">
              <a href="https://t.me/justdisplay" target="_blank" rel="noopener noreferrer" className="header-btn header-btn-primary">
                Написать
              </a>
              <button onClick={() => { setIsLoginOpen(true); setIsMenuOpen(false); }} className="header-btn header-btn-secondary">
                Консоль
              </button>
            </div>
          </nav>

          <button 
            className="header-menu-toggle"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </motion.header>
      <LoginModal isOpen={isLoginOpen} onClose={() => setIsLoginOpen(false)} />
    </>
  );
};

export default Header;
